<template>
  <div id="formulario-edit-info">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vs-prompt color="primary" :active.sync="popupDuplicar.popupActive" title="Duplicar Conta Múltiplas Vezes"     
      @accept="duplicarMultiploRequest"      
      :is-valid="popupDuplicar.quantidadeDuplicacao > 0 "
      acceptText="Duplicar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            Informe o número de vezes que deseja duplicar:
            <vs-input v-model="popupDuplicar.quantidadeDuplicacao" type="number"/>                     
       </div>
    </vs-prompt>

    <vs-prompt color="primary" :active.sync="popupEnvioEmail.popupActive" title="Enviar Boleto por Email"     
      @accept="enviarBoletoRequest"            
      acceptText="Enviar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            <div> 
                <label class="vs-input--label">Copiar email para:</label>    
                <vs-input v-model="popupEnvioEmail.emailDestinatarioCopia" type="email" class="w-full"/>      
            </div>
            <div class="mt-2">
                <label class="vs-input--label">Enviar para o WhatsApp:</label>    
                <vs-input v-model="popupEnvioEmail.numeroWhatsapp" class="w-full"/>            
            </div>
       </div>
    </vs-prompt>

    <vs-prompt color="primary" :active.sync="popupAprovar.popupActive" title="Aprovar Conta"     
      @accept="aprovarRequest"      
      :is-valid="popupAprovar.tipoPagamento"
      acceptText="Aprovar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            Informe o tipo do pgamento:
            <v-select                                                                     
                :options="CONSTANTE_TIPO_LANCAMENTO"  
                :reduce="d => d.data"                 
                v-model="popupAprovar.tipoPagamento"     
                class="v-select w-full"
            ></v-select>  
       </div>
    </vs-prompt>

    <vs-prompt color="primary" :active.sync="popupInserirAprovar.popupActive" title="Inserir e Aprovar Conta"     
      @accept="gravarAprovarRequest"      
      :is-valid="popupInserirAprovar.tipoPagamento"
      acceptText="Aprovar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            Informe o tipo do pgamento:
            <v-select                                                                     
                :options="CONSTANTE_TIPO_LANCAMENTO"  
                :reduce="d => d.data"                 
                v-model="popupInserirAprovar.tipoPagamento"     
                class="v-select w-full"
            ></v-select>  
       </div>
    </vs-prompt>

    <vs-popup title="Item Conta a Receber" :active.sync="popUpItemContaAReceber.popupActive">
        <vs-alert color="danger" :active.sync="popUpItemContaAReceber.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                {{popUpItemContaAReceber.mensagem}}
        </vs-alert> 
        <div class="vx-row mb-2">               
            <div class="vx-col w-full">
                <label class="vs-input--label">Descrição</label> 
                <vs-input class="w-full" v-model="itemContaAReceber.descricaoItem" :maxlength="1024" :disabled="data_local.status !== 'PROVISORIA'"/>   
            </div>
        </div>
        <div class="vx-row mb-2">               
            <div class="vx-col w-1/2">
                <label class="vs-input--label">Quantidade</label> 
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="data_local.status !== 'PROVISORIA'" v-model="itemContaAReceber.qtd" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>              
            </div>            
            <div class="vx-col w-1/2">
                <label class="vs-input--label">Valor Unitário</label>     
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="data_local.status !== 'PROVISORIA'" v-model="itemContaAReceber.precoUnitario" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                              
            </div>            
        </div>
        <div class="vx-row mb-2" v-if="isConcept">               
            <div class="vx-col w-full">
                <label class="vs-input--label">CNAE</label>                
                 <v-select                                               
                        :options="CONSTANTE_CNAES" 
                        :disabled="data_local.status !== 'PROVISORIA'"
                        v-model="itemContaAReceber.cnaeEmissaoNotaFiscal"      
                        :reduce="r => r.data"    
                        @input="onSelectedCnae"                                              
                        class="v-select w-full">
                    </v-select> 
            </div>
        </div>
        <div class="vx-row mb-2" v-if="isConcept">               
            <div class="vx-col w-1/2">
                <label class="vs-input--label">Incluir na Nota Fiscal ?</label>
                <vs-checkbox class="w-full mt-2" v-model="itemContaAReceber.incluirEmNotaFiscal" :disabled="data_local.status !== 'PROVISORIA' || (itemContaAReceber.cnaeEmissaoNotaFiscal && recuperarCnae(itemContaAReceber.cnaeEmissaoNotaFiscal) && !recuperarCnae(itemContaAReceber.cnaeEmissaoNotaFiscal).emiteNF)"/>   
            </div>
        </div>
       
        <div class="flex w-full">
            <vs-button class="mr-2 mt-2" size="small" @click="popUpItemContaAReceber.popupActive = false" color="dark" v-if="data_local.status === 'PROVISORIA' ">FECHAR</vs-button>                              
            <vs-button class="mr-auto mt-2" size="small" @click="inserirItemContaAReceber" color="success" v-if="data_local.status === 'PROVISORIA' && !popUpItemContaAReceber.naoExibirBotaoInserir ">INSERIR</vs-button>            
        </div>
    </vs-popup>

    <vs-popup title="Pagamento" :active.sync="popUpLancamento.popupActive">
        <vs-alert color="danger" :active.sync="popUpLancamento.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                {{popUpLancamento.mensagem}}
        </vs-alert> 
        <div id="div2-with-loading" class="vs-con-loading__container">
            <div class="flex w-full justify-center mb-2">
                <vs-button type="border" class="ml-2" size="small" @click="gerarNFSe()" color="dark" v-if="itemLancamento.hasOwnProperty('numeroLancamento') && itemLancamento.nfeNumero">NFSe</vs-button>            
                <vs-button type="border" class="ml-2" size="small" @click="gerarFatura()" color="dark" v-if="itemLancamento.hasOwnProperty('numeroLancamento') && isExibirFaturaLocacao">FATURA</vs-button>            
                <vs-button type="border" class="ml-2" size="small" @click="gerarBoleto()" color="dark" v-if="itemLancamento.hasOwnProperty('numeroLancamento') && itemLancamento.status !== 'EFETUADO' ">BOLETO</vs-button>                            
                <vs-button type="border" class="ml-2" size="small" @click="gerarRecibo()" color="dark">RECIBO</vs-button>            
                <vs-button type="border" class="ml-2" size="small" @click="gerarCartaCobranca()" color="dark" v-if="itemLancamento.status !== 'EFETUADO' ">CARTA DE COBRANÇA</vs-button>            
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-1/3">
                    <label class="vs-input--label" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">Número</label>    
                    <h5 class="ml-3" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">{{ itemLancamento.numeroLancamento }}</h5>
                </div>
                <div class="vx-col w-1/3">
                    <label class="vs-input--label" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">Status</label>    
                    <h5 class="ml-3" v-if="itemLancamento.hasOwnProperty('status')">{{ itemLancamento.status }}</h5>
                </div>
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Emitir NF ?</label>                        
                    <vs-checkbox class="w-full mt-2" v-model="itemLancamento.emitirNF" :disabled="isDesabilitarCampoLancamento"/> 
                </div>               
            </div>        
            <div class="vx-row mb-2">               
                <div class="vx-col w-3/4">
                    <label class="vs-input--label">Tipo</label>   
                    <v-select                                                                     
                        :options="CONSTANTE_TIPO_LANCAMENTO"  
                        :reduce="d => d.data"          
                        :disabled="isDesabilitarCampoLancamento"       
                        v-model="itemLancamento.tipo"     
                        class="v-select w-full"
                    ></v-select>  
                </div>
                 <div class="vx-col w-1/4">
                    <label class="vs-input--label">Nota Fiscal</label>                        
                    <vs-input :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.nfeNumero"  class="w-full"/>
                </div>
            </div>   
            <div class="vx-row mb-2">               
                <div class="vx-col w-full">
                    <label class="vs-input--label">Pagar através de</label>   
                    <v-select          
                        label="nome"  
                        :disabled="isDesabilitarCampoLancamento"                                               
                        :options="listaInstituicao"                   
                        v-model="itemLancamento.instituicao"                         
                        class="v-select w-full"></v-select> 
                </div>
            </div>             
            <div class="vx-row mb-2">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Data de Vencimento</label>           
                    <flat-pickr v-model="itemLancamento.data" class="mb-4 w-full" :config="configDatePicker" :disabled="isDesabilitarCampoLancamento" />                
                    </div>             
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Data de Pagamento</label>
                    <flat-pickr v-model="itemLancamento.dataEfetivacao" class="mb-4 w-full" :config="configDatePicker" :disabled="isDesabilitarCampoLancamento"/>              
                    <div class="flex">
                        <vs-button class="mt-2" size="small" @click="copiarVencimento" color="primary" :disabled="isDesabilitarCampoLancamento" v-if="exibirGravarLancamento()">No Vencimento</vs-button>
                        <vs-button class="ml-auto mt-2" size="small" @click="setarDataEfetivacaoHoje" color="primary" :disabled="isDesabilitarCampoLancamento" v-if="exibirGravarLancamento()">Hoje</vs-button>
                    </div>
                </div> 
            </div>        
            <div class="vx-row mb-2">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor</label> 
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.valor" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>              
                </div>            
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor Pago</label>     
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.valorEfetivado" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>          
                    <vs-button class="mt-2" size="small" @click="copiarValor" color="primary" :disabled="isDesabilitarCampoLancamento" v-if="exibirGravarLancamento()">Mesmo que o Valor</vs-button>
                </div>            
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea counter="4098" class="w-full" label="Complemento" :maxlength="4098" v-model="itemLancamento.complemento" :disabled="isDesabilitarCampoLancamento"/>                
                </div>                
            </div>    
            <div class="vx-row">
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Enviado Setor Cobrança ?</label>
                    <vs-checkbox class="w-full mt-2" v-model="itemLancamento.enviadoParaJuridico" :disabled="isDesabilitarCampoLancamento"/> 
                </div>                                             
                <div class="vx-col w-1/3">            
                    <label class="vs-input--label">Percentual Desconto </label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.descontoPontualidade" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2', emptyInputBehavior: 'null' }]"></vue-autonumeric>                 
                </div>
                <div class="vx-col w-1/3">            
                    <label class="vs-input--label">Data para Desconto </label>
                    <flat-pickr :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.dataParaDesconto" class="mb-4 w-full" :config="configDatePicker" />              
                </div>
            </div>           
            <div class="flex w-full">
                <div class="ml-auto"></div>
                <vs-button class="ml-2 mt-2" size="small" @click="gravarLancamento('ABERTO')" color="success" v-if="exibirGravarLancamento()">GRAVAR</vs-button>            
                <vs-button class="ml-2 mt-2" size="small" @click="gravarLancamento('EFETUADO')" color="primary" v-if="exbirEfetuarLancamento()">EFETUAR</vs-button>            
                <vs-button class="ml-2 mt-2" size="small" @click="gravarLancamento('DESEFETUAR')" color="danger" v-if="exibirDesefetuarLancamento()">DESEFETUAR</vs-button>                            
            </div>
        </div>
    </vs-popup>

    <vx-card>
        <div id="div-with-loading-conta" class="vs-con-loading__container">
            <div class="vx-row mb-4">
                <div class="vx-col w-2/3 ">                    
                    <vs-button class="ml-auto mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>     
                    <vs-button class="ml-4 mt-2" size="small" @click="gravar"        v-if="isExibirGravar" color="success">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="gravarAprovar" v-if="isExibirGravarEAprovar" color="success">Gravar e Aprovar</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="cancelar"       v-if="isExibirCancelar" color="danger">Cancelar</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir"       v-if="isExibirExcluir" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="duplicarMultiplo"      v-if="isExibirDuplicar"   color="dark">Duplicar Múltiplo</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="duplicar"      v-if="isExibirDuplicar"   color="dark">Duplicar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="aprovar"       v-if="isExibirAprovar" color="primary">Aprovar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="desaprovar"    v-if="isExibirDesaprovar" color="danger">Desaprovar</vs-button>                
                            
                </div>
                <div class="vx-col w-1/6 items-center flex">                                    
                    Número: <h3 class="ml-2">{{data_local.numeroConta}}</h3>    
                </div>  
                <div class="vx-col w-1/6 items-center flex">                                    
                    <p class="ml-auto"> Status: </p> <h6 class="ml-2"> {{ data_local.status }}</h6>                     
                </div>  
            </div>
            <div class="vx-row">            
                <div class="vx-col w-1/2"><label class="vs-input--label">Unidade Operacional</label></div>                 
                <div class="vx-col w-1/2"><label class="vs-input--label">Pagar Através de</label></div>                   
            </div>    
            <div class="vx-row">
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaUnidadeOperacional"                   
                        v-model="data_local.unidadeOperacional"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select> 
                </div>          
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaInstituicao"                   
                        v-model="data_local.instituicao"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>    
                </div>              
            </div>    
            <div class="vx-row mt-3">
                <div class="vx-col w-1/2"><label class="vs-input--label">Plano de Conta</label></div>                             
                <div class="vx-col w-1/2"><label class="vs-input--label">Cliente</label></div>                             
            </div>    
            <div class="vx-row">
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaContaPlanoConta"                   
                        v-model="data_local.contaPlanoConta"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>   
                </div>                     
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaFavorecido"          
                        :filter="pesquisarFavorecido"         
                        v-model="data_local.favorecido"     
                        :disabled="isDesabilitarCampo"  
                        class="v-select w-full">
                        <template v-slot:option="option">                        
                            <span style='font-family: Verdana, sans-serif;'> {{ option.nome }} </span> <br/> {{ option.cpfCNPJ }}  - {{ option.razaoSocial }}
                        </template>
                    </v-select>    
                </div>                     
            </div> 
            <div class="vx-row mt-3">
                <div class="vx-col w-1/3"><label class="vs-input--label">Vencimento</label></div>                                                     
                <div class="vx-col w-1/3 flex"><label class="vs-input--label">Valor </label> <small class="ml-auto">Saldo em aberto: R$ {{ saldoEmAbertoFormatado }}</small> </div>   
                <div class="vx-col w-1/3"><label class="vs-input--label">Forma de Pagamento</label></div>                                                                                                                                 
            </div>                    
            <div class="vx-row">
                <div class="vx-col w-1/3 flex">
                    <flat-pickr v-model="data_local.vencimento" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
                </div>                                             
                <div class="vx-col w-1/3">            
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.valor" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>
                <div class="vx-col w-1/3 flex">
                    <v-select                                                                     
                        :options="CONSTANTE_FORMA_PAGAMENTO"  
                        :reduce="d => d.data"                 
                        v-model="data_local.formaPagamento"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>    
                </div>    
            </div>   
            <div class="vx-row mt-3">                                                               
                <div class="vx-col w-1/3"><label class="vs-input--label">Notas Fiscais Emitidas</label></div>                                        
                <div class="vx-col w-1/3"><label class="vs-input--label">Faturas/Recibos</label></div>                 
            </div>    
            <div class="vx-row">                        
                <div class="vx-col w-1/3 flex">
                    <vs-input class="w-full" v-model="data_local.numeroNotaFiscal" :disabled="isDesabilitarCampo" :maxlength="45"/>   
                </div>                  
                <div class="vx-col w-1/3 flex">
                    <vs-input class="w-full" v-model="data_local.contratoRecibo" :maxlength="45" :disabled="isDesabilitarCampo"/>   
                </div>                                          
            </div>                  
            <div class="vx-row mt-3">
                <div class="vx-col w-1/2"><label class="vs-input--label">Complemento</label></div>     
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                <vs-textarea class="w-full" rows="5" v-model="data_local.complemento" :maxlength="255" :disabled="isDesabilitarCampo"/>   
                </div>     
            </div>
            <div class="vx-row">
                <div class="vx-col w-1/3">
                    <label class="vs-input--label">Enviar Aviso em </label>
                    <flat-pickr v-model="data_local.dataProgramadaEnvioAviso" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
                </div>                                             
                <div class="vx-col w-1/3">            
                    <label class="vs-input--label">Percentual Desconto </label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.percentualDescontoPontualidade" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2', emptyInputBehavior: 'null' }]"></vue-autonumeric>                 
                </div>
                <div class="vx-col w-1/3">            
                    <label class="vs-input--label">Dias para Desconto </label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.diasAntecedentesVencimentoParaDesconto" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0', emptyInputBehavior: 'null' }]"></vue-autonumeric>                 
                </div>
             </div>
        </div>
    </vx-card>  
    
    <vx-card class="mt-3">
        <h6> Itens </h6>
        <div class="flex mb-2 mt-2">            
            <vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="abrirPopUpItemContaAReceber()" v-if="data_local.status === 'PROVISORIA' "></vs-button>             
            <h5 class="ml-auto"> Total: {{valorTotalItensFormatado}}</h5>
        </div>
        <div id="div-with-loading-itens" class="vs-con-loading__container">
            <vs-table :data="listaItensContaAReceber" noDataText="Nenhum Item." stripe v-model="itemContaAReceber" @selected="editarPopUpItemContaAReceber">
                <template slot="thead">
                    <vs-th style="width:40px"></vs-th>
                    <vs-th style="width:40px"></vs-th>
                    <vs-th><small>Descrição</small></vs-th>                                
                    <vs-th><small>Qtd</small></vs-th>                              
                    <vs-th><small>Unitário</small></vs-th>                              
                    <vs-th><small>Total</small></vs-th>
                    <vs-th v-if="isConcept"><small>CNAE</small></vs-th>
                    <vs-th v-if="isConcept"><small>Incluir na NF</small></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">                    
                        <vs-td>
                            <div class="btn-group flex">
                                <vs-button size="small" type="filled" color="danger" icon-pack="feather" icon="icon-trash" v-if="data_local.status === 'PROVISORIA' && isExibirGravar" @click.stop="removerItemContaAReceber(indextr)"></vs-button>
                                <vs-button size="small" type="filled" color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                            </div>
                        </vs-td>
                        <vs-td :data="indextr">
                            <small>{{ (indextr + 1)}}</small>
                        </vs-td>
                        <vs-td :data="tr.descricaoItem"><small> {{ tr.descricaoItem }} </small></vs-td>
                        <vs-td :data="tr.qtd"> <small>{{ tr.qtd }} </small> </vs-td>                        
                        <vs-td :data="tr.precoUnitario"><small> {{ formatarNumero(tr.precoUnitario) }} </small></vs-td>
                        <vs-td ><small v-if="tr.precoUnitario"> {{ cacularTotalItem(tr.qtd , tr.precoUnitario) }}</small></vs-td>
                        <vs-td v-if="isConcept" :data="tr.cnaeEmissaoNotaFiscal"> <small v-if="recuperarCnae(tr.cnaeEmissaoNotaFiscal)">{{ recuperarCnae(tr.cnaeEmissaoNotaFiscal).codigo}} </small> </vs-td>                        
                        <vs-td v-if="isConcept" :data="tr.incluirEmNotaFiscal"> 
                            <vs-icon icon="done_outline" color="success" v-if="tr.incluirEmNotaFiscal"/> 
                            <vs-icon icon="block" color="danger" v-if="!tr.incluirEmNotaFiscal"/>                             
                        </vs-td>                        
                        
                    </vs-tr>
                </template>
            </vs-table>
        </div>        
    </vx-card>

    <vx-card class="mt-3" v-if="isExibirListaPagamentos">
        <h6> Pagamentos </h6>
        <div class="flex mb-2 mt-2">
            <vs-button size="small" class="nowrap" icon="search" color="primary" @click="fetchListaLancamentos()"></vs-button>             
            <vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="novoLancamento()" v-if="isExibirNovoLancamento"></vs-button>             
            <h5 class="ml-auto"> Total: {{valorTotalPagamentosFormatado}}</h5>
        </div>
        <div id="div-with-loading" class="vs-con-loading__container">
            <vs-table :data="listaLancamentos" noDataText="Nenhum Pagamento." stripe v-model="itemLancamento" @selected="editarLancamento">
                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th style="width: 10px"></vs-th>
                    <vs-th><small>Tipo</small></vs-th>                                
                    <vs-th><small>Número</small></vs-th>                              
                    <vs-th><small>Nota Fiscal</small></vs-th>                              
                    <vs-th><small>Status</small></vs-th>                              
                    <vs-th><small>Vencimento</small></vs-th>
                    <vs-th><small>Pagamento</small></vs-th>
                    <vs-th><small>Valor</small></vs-th>
                    <vs-th><small>Valor Pago</small></vs-th>                
                    <vs-th><small>Setor Cobrança</small></vs-th>                
                    <vs-th><small>Boleto Registrado</small></vs-th>
                    <vs-th><small>Envio Aviso</small></vs-th>
                    
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <div class="btn-group flex">
                                <vs-button size="small" type="border"  @click.stop="excluirLancamento(tr)" icon-pack="feather" icon="icon-trash" color="danger" v-if="exibirExcluirLancamento(tr)"></vs-button>            
                                <vs-button size="small" type="border" color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                                <vs-button size="small" type="border"  @click.stop="enviarBoleto(tr)" icon-pack="feather" icon="icon-send" color="dark" v-if="tr.status !== 'EFETUADO' "></vs-button>                                 
                            </div>
                        </vs-td>
                        <vs-td :data="indextr">
                            <small>{{ (indextr + 1)}}</small>
                        </vs-td>
                        <vs-td :data="tr.tipo"><small> {{ tr.tipo }} </small></vs-td>
                        <vs-td :data="tr.numeroLancamento"><small> {{ tr.numeroLancamento }} </small> </vs-td>
                        <vs-td :data="tr.nfeNumero"><small> {{ tr.nfeNumero }} </small> </vs-td>
                        <vs-td :data="tr.status"><small> {{ tr.status }} </small></vs-td>
                        <vs-td :data="tr.data"><small> {{ tr.dataFormatada }} </small></vs-td>
                        <vs-td :data="tr.dataEfetivacao"><small v-if="tr.dataEfetivacao"> {{ tr.dataEfetivacaoFormatada }} </small></vs-td>
                        <vs-td :data="tr.valor"><small> {{ formatarNumero(tr.valor) }} </small> <div v-if="tr.valor !== tr.valorAtualizado"> <br/> <small>{{ formatarNumero(tr.valorAtualizado) }}</small> </div></vs-td>
                        <vs-td :data="tr.valorEfetivado"><small v-if="tr.valorEfetivado"> {{ formatarNumero(tr.valorEfetivado) }} </small></vs-td>
                        <vs-td :data="tr.enviadoParaJuridico"> <vs-icon icon="done_outline" color="success" v-if="tr.enviadoParaJuridico"/> </vs-td>
                        <vs-td :data="tr.boletoRegistrado"> <vs-icon icon="done_outline" color="success" v-if="tr.boletoRegistrado"/> </vs-td>
                        <vs-td :data="tr.dataEnvioAviso"><small v-if="tr.dataEnvioAviso"> {{ tr.dataEnvioAvisoFormatada }} </small></vs-td>
                       
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vx-card>
  </div>
</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'


const URL_SERVLET = "/Conta";
const NAME_ROUTE_SEARCH = "financeiro-contas-a-receber-pesquisar";

import { CONSTANTE_FORMA_PAGAMENTO } from '@/constantesComboBox.js'
import { CONSTANTE_TIPO_LANCAMENTO } from  '@/constantesComboBox.js'
import { CONSTANTE_CNAES } from  '@/constantesComboBox.js'

export default { 
  components: {  
    VueAutonumeric,
    flatPickr    
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { numeroConta: null, unidadeOperacional: null, contaPlanoConta: null, favorecido: null, vencimento: null, dataProgramadaEnvioAviso: null, valor: null, 
            formaPagamento: null, instituicao: null, numeroNotaFiscal: null, contratoRecibo: null, complemento: null, percentualDescontoPontualidade: null, 
            diasAntecedentesVencimentoParaDesconto: null, status: 'PROVISORIA', saldoEmAberto: 0 }
       }
    },
  },
  data() {
    return {        
        listaUnidadeOperacional: [],
        listaContaPlanoConta: [],
        listaFavorecido: [],
        listaInstituicao: [],
        listaLancamentos: [],
        listaItensContaAReceber: [],
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),     
        configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
        },              
        popUpLancamento : {
            popupActive: false,
            exibirMensagem: false,
            mensagem: null
        }, 
        popupDuplicar: {
            popupActive: false,
            quantidadeDuplicacao: 0
        },
        popUpItemContaAReceber : {
            popupActive: false,
            exibirMensagem: false,
            mensagem: null,
            naoExibirBotaoInserir: false,
        }, 
        popupEnvioEmail: {
            popupActive: false,
            emailDestinatarioCopia: null,
            numeroWhatsapp: null
        },
        popupAprovar :{
            popupActive: false,
            tipoPagamento: null
        },
        popupInserirAprovar:{
            popupActive: false,
            tipoPagamento: null
        },
        itemLancamento: {status: null, tipo: 'NAO_INFORMADO', data: null, dataEfetivacao: null, valor: null, valorEfetivado: null, complemento: null, instituicao: null, descontoPontualidade: null, 
         dataParaDesconto: null, enviadoParaJuridico: false, emitirNF: false , nfeNumero: null},
        itemContaAReceber :{descricaoItem: null, qtd: null, precoUnitario: null, incluirEmNotaFiscal:true, cnaeEmissaoNotaFiscal: null }
    }
  },  
  created(){
        this.CONSTANTE_FORMA_PAGAMENTO = CONSTANTE_FORMA_PAGAMENTO;           
        this.CONSTANTE_TIPO_LANCAMENTO = CONSTANTE_TIPO_LANCAMENTO;
        this.CONSTANTE_CNAES = CONSTANTE_CNAES; 
  }, 
  mounted() {
    this.fetchListaUnidadeOperacional();
    this.fetchListaContaPlanoConta();
    this.fetchListaFavorecido();
    this.fetchListaInstituicao();      
    if (this.data_local != null && this.data_local.hasOwnProperty('id')) {        
        this.findById();            
    } else {        
        this.data_local.formaPagamento = this.CONSTANTE_FORMA_PAGAMENTO[0].data;        
    }
  },
  computed: {  
    isConcept(){
        return this.$store.state.AppActiveUser.empresa.id === 1 || this.$store.state.AppActiveUser.empresa.id === 25;
    },
    valorTotalItens(){
        if (!this.listaItensContaAReceber || this.listaItensContaAReceber.length == 0) {
            return 0;
        }

        let lItem = null;
        let valorTotal = 0;
        for (var i=0; i < this.listaItensContaAReceber.length; i++) {
            lItem = this.listaItensContaAReceber[i];
            valorTotal = valorTotal + parseFloat(lItem.qtd)*parseFloat(lItem.precoUnitario) ;                
        }

        return valorTotal;
    },    
    valorTotalItensFormatado(){        
        return generico.formatarNumero(this.valorTotalItens);        
    },
    isExibirExcluir() {
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

       return permissao && this.data_local != null && ( this.data_local.status === 'PROVISORIA' || this.data_local.status === 'CANCELADA' ) && this.data_local.hasOwnProperty("id");
    },    
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.status !== 'PROVISORIA';
    },
    isDesabilitarCampoLancamento(){
        return this.itemLancamento != null && this.itemLancamento.status === 'EFETUADO';
    },
    isExibirGravar(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

        return this.data_local != null && this.data_local.status === 'PROVISORIA' && permissao;
    },
    isExibirGravarEAprovar(){
        return this.data_local != null && this.data_local.status === 'PROVISORIA' && !this.data_local.hasOwnProperty("id");
    },
    isExibirCancelar(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }
        return permissao && this.data_local != null && ( this.data_local.status === 'ABERTA' || this.data_local.status === 'PROVISORIA' ) && this.data_local.hasOwnProperty("id");
    },
    isExibirAprovar(){
       let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        } 
       return permissao && this.data_local != null && this.data_local.status === 'PROVISORIA' && this.data_local.hasOwnProperty("id");
    },
    isExibirDesaprovar() {
        let permissao = false;
        if ((this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }
        return permissao && this.data_local != null && this.data_local.status === 'ABERTA' && this.data_local.hasOwnProperty("id");
    },
    isExibirNovoLancamento(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }
        return permissao && this.data_local != null && this.data_local.status === 'ABERTA' && this.data_local.hasOwnProperty("id");
    },
    isExibirListaPagamentos(){
        return this.data_local != null && (this.data_local.status === 'ABERTA' || this.data_local.status === 'PAGA') && this.data_local.hasOwnProperty("id");
    },
    isExibirDuplicar(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }
        return permissao && this.data_local != null && this.data_local.hasOwnProperty("id");
    },
    isExibirDuplicarMultiplo(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }
        return permissao && this.data_local != null && this.data_local.hasOwnProperty("id");
    },
    saldoEmAbertoFormatado(){
        return generico.formatarNumero(parseFloat(this.data_local.saldoEmAberto));
    },
    valorTotalPagamentos(){
        if (!this.listaLancamentos || this.listaLancamentos.length == 0) {
            return 0;
        }

        let lItem = null;
        let valorTotal = 0;
        for (var i=0; i < this.listaLancamentos.length; i++) {
            lItem = this.listaLancamentos[i];
            valorTotal = valorTotal + parseFloat(lItem.valor) ;                
        }

        return valorTotal;
    },    
    valorTotalPagamentosFormatado(){        
        return generico.formatarNumero(this.valorTotalPagamentos);        
    },
    isExibirFaturaLocacao(){
        if (!this.listaItensContaAReceber || this.listaItensContaAReceber.length == 0) {
            return false;
        }
        
        let lItem = null;
        for (var i = 0; i < this.listaItensContaAReceber.length; i++) {
            lItem = this.listaItensContaAReceber[i];
            if (lItem.cnaeEmissaoNotaFiscal === '773310000') {
                return true;
            }
        }

        return false;
    },   

  },
  methods: { 
    recuperarCnae(cnae) {
        const elemento = CONSTANTE_CNAES.find(item => String(item.data) === String(cnae));        
        return elemento;
    },
    onSelectedCnae(cnaeSelecionado) {        
        const elemento = this.recuperarCnae(cnaeSelecionado);  
        if (elemento) {
            this.itemContaAReceber.incluirEmNotaFiscal =  elemento.emiteNF;
        } else {
            this.itemContaAReceber.incluirEmNotaFiscal =  false;
        }
    },
    pesquisarFavorecido(options, varTermoPesquisa) {
        if (!varTermoPesquisa) {
            return;
        }
        varTermoPesquisa = varTermoPesquisa.toUpperCase();
        return options.filter(function (c) {
            return ( ( String(c.nome).toUpperCase().indexOf(varTermoPesquisa) != -1)  || (String(c.razaoSocial).toUpperCase().indexOf(varTermoPesquisa) != -1) || 
            ( String(c.cpfCNPJ).indexOf(varTermoPesquisa) != -1));
        })
    }, 
    exibirDesefetuarLancamento(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

        return permissao && this.itemLancamento.status === 'EFETUADO'
    },
    exbirEfetuarLancamento(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
             (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
             permissao =  true;   
        }

        return permissao && this.itemLancamento.status === 'ABERTO';
    },
    exibirGravarLancamento(){
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        } else if ( !this.itemLancamento.hasOwnProperty('id') && ((this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
                    (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO'))
                  ) {
            permissao =  true;   
        }

        return permissao && this.itemLancamento.status !== 'EFETUADO';
    },
    exibirExcluirLancamento(tr) {
        let permissao = false;
        if ((this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

        return permissao && tr.status === 'ABERTO';
    },
    exibirEfetuarLancamento(tr) {
        let permissao = false;
        if ( (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

        return permissao && tr.status === 'ABERTO';
    },
    formularioValidoItemContaAReceber() {
        
        if (!this.itemContaAReceber.descricaoItem) {
            this.popUpItemContaAReceber.mensagem = "Descrição do item obrigatório.";
            this.popUpItemContaAReceber.exibirMensagem = true;
            return false;
        }

        if (!this.itemContaAReceber.qtd) {
            this.popUpItemContaAReceber.mensagem = "Quantidade do item obrigatório.";
            this.popUpItemContaAReceber.exibirMensagem = true;
            return false;
        }

        if (!this.itemContaAReceber.precoUnitario) {
            this.popUpItemContaAReceber.mensagem = "Preço Unitário do item obrigatório.";
            this.popUpItemContaAReceber.exibirMensagem = true;
            return false;
        }    
      
        return true;
    },   
    cacularTotalItem(qtd, valorUnitario){
        return generico.formatarNumero(parseFloat(qtd) * parseFloat(valorUnitario));
    },
    inserirItemContaAReceber() {
        if (this.formularioValidoItemContaAReceber()) {
            this.listaItensContaAReceber.push(this.itemContaAReceber);
            this.itemContaAReceber = {descricaoItem: null, qtd: null, precoUnitario: null, incluirEmNotaFiscal:true, cnaeEmissaoNotaFiscal: null };
        }
    },
    removerItemContaAReceber(indice){
        let _self = this;
         this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir o item?', acceptText: 'Sim', cancelText: 'Não', accept: function() { _self.removerItemContaAReceberRequest(indice); }
        });
    },
    removerItemContaAReceberRequest(indice) {      
      this.listaItensContaAReceber.splice(indice,1);
    },
    abrirPopUpItemContaAReceber() {          
        this.popUpItemContaAReceber.mensagem = null;
        this.popUpItemContaAReceber.popupActive = true;
        this.itemContaAReceber = {descricaoItem: null, qtd: null, precoUnitario: null, incluirEmNotaFiscal:true, cnaeEmissaoNotaFiscal: null };
        this.popUpItemContaAReceber.naoExibirBotaoInserir = false;
    },
    editarPopUpItemContaAReceber() {          
        this.popUpItemContaAReceber.mensagem = null;
        this.popUpItemContaAReceber.popupActive = true;         
        if (this.itemContaAReceber.cnaeEmissaoNotaFiscal) {
            this.itemContaAReceber.cnaeEmissaoNotaFiscal = String(this.itemContaAReceber.cnaeEmissaoNotaFiscal);
        }
        this.popUpItemContaAReceber.naoExibirBotaoInserir = true;
    },
    setarDataEfetivacaoHoje() {
        var hoje = new Date();            
        this.itemLancamento.dataEfetivacao = hoje.toISOString().split('T')[0];
    },
    copiarVencimento(){
        this.itemLancamento.dataEfetivacao = this.itemLancamento.data;
    },
    copiarValor(){
        this.itemLancamento.valorEfetivado = this.itemLancamento.valor;
    },
    editarLancamento(){
        this.findLancamentoById();
        this.abrirPopUpItemLancamento();
    },
    novoLancamento(){
        this.itemLancamento = {status: null, tipo: 'NAO_INFORMADO', data: null, dataEfetivacao: null, valor: null, valorEfetivado: null, complemento: null, instituicao: null, descontoPontualidade: null, dataParaDesconto: null, enviadoParaJuridico: false, emitirNF: false , nfeNumero: null};
        this.abrirPopUpItemLancamento();
    },
    abrirPopUpItemLancamento() {  
        if (!this.itemLancamento.hasOwnProperty('dataEfetivacao')) {
            this.$set(this.itemLancamento, 'dataEfetivacao', null);
        }
        if (!this.itemLancamento.hasOwnProperty('valorEfetivado')) {
            this.$set(this.itemLancamento, 'valorEfetivado', null);
        }
        if (!this.itemLancamento.hasOwnProperty('complemento')) {
            this.$set(this.itemLancamento, 'complemento', null);
        }
        if (!this.itemLancamento.hasOwnProperty('nfeNumero')) {
            this.$set(this.itemLancamento, 'nfeNumero', null);
        }
        if (!this.itemLancamento.hasOwnProperty('descontoPontualidade')) {
            this.$set(this.itemLancamento, 'descontoPontualidade', null);
        }
        if (!this.itemLancamento.hasOwnProperty('dataParaDesconto')) {
            this.$set(this.itemLancamento, 'dataParaDesconto', null);
        }
        this.popUpLancamento.exibirMensagem = false;
        this.popUpLancamento.mensagem = null;
        this.popUpLancamento.popupActive = true;
    },
    formatarNumero(valor) {
        return generico.formatarNumero(valor);
    },
    fetchListaUnidadeOperacional() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/UnidadeOperacional/ListarUnidadeOperacional", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaUnidadeOperacional = response.data.Resultado.lista;              

              if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaUnidadeOperacional.length > 0) {
                    this.data_local.unidadeOperacional = this.listaUnidadeOperacional[0];
              }
              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaContaPlanoConta() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('grupoPlanoConta.tipo',  'RECEITA');
            
      axios.post("/ContaPlanoConta/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaContaPlanoConta = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaFavorecido() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('ehCliente',  true);
      
      axios.post("/Favorecido/ListarFavorecido", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaFavorecido = response.data.Resultado.lista;                            
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaInstituicao() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('funcaoInstituicao', 'CONTAS_A_RECEBER');
            
      axios.post("/Instituicao/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaInstituicao = response.data.Resultado.lista;              

              if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaInstituicao.length > 0) {
                    this.data_local.instituicao = this.listaInstituicao[0];
              }
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaLancamentos() {      
      
      this.$vs.loading({ container: '#div-with-loading', scale: 0.6 })
      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('conta.id',  this.data_local.id);
                  
      axios.post("/Lancamento/ListarLancamento", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading');
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaLancamentos = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })     
      
    }, 
    findById() {
        this.$vs.loading({container: '#div-with-loading-conta', scale: 0.6});
        this.$vs.loading({ container: '#div-with-loading-itens', scale: 0.6 })
        this.listaLancamentos = [];
        this.listaItensContaAReceber = [];

        const params = new URLSearchParams();       
        params.append('cliente.id', this.$store.state.AppActiveUser.id);      
        params.append('empresa.id', this.$store.state.AppActiveUser.empresa.id);    
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarConta", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close('#div-with-loading-conta > .con-vs-loading');
            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.data_local = response.data.Conta;   
                
                if (!this.data_local.hasOwnProperty('percentualDescontoPontualidade')) {
                    this.$set(this.data_local, 'percentualDescontoPontualidade', null);                    
                }
                                
                if (response.data.Conta.itemList && Array.isArray(response.data.Conta.itemList)) {                    
                  this.listaItensContaAReceber = response.data.Conta.itemList;
                } else if (response.data.Conta.itemList &&  !Array.isArray(response.data.Conta.itemList) ) {                    
                    this.listaItensContaAReceber = [];
                    this.listaItensContaAReceber.push(response.data.Conta.itemList);
                } else {                    
                    this.listaItensContaAReceber = [];
                }

                this.$vs.loading.close('#div-with-loading-itens > .con-vs-loading')
                                 
                if (this.data_local.status === 'ABERTA' || this.data_local.status === 'PAGA') {                    
                    this.fetchListaLancamentos();                
                }  
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - findById - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverConta", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    },    
    desaprovar(){
        if (this.verificarAlgumBoletoRegistrado()) {
            this.$vs.dialog({
                type: 'confirm', color: 'warning', title: 'Atenção', text: 'Existe pelo menos um pagamento com boleto registrado. Deseja DESAPROVAR a conta mesmo assim ?', acceptText: 'Sim', cancelText: 'Não', accept: this.cancelarRequest
            });
        } else {
            this.$vs.dialog({
            type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja DESAPROVAR a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.desaprovarRequest
            });
        }
    },
    desaprovarRequest(){
        this.submeter("/DesaprovarConta");
    },
    cancelar(){
        if (this.verificarAlgumBoletoRegistrado()) {
            this.$vs.dialog({
                type: 'confirm', color: 'warning', title: 'Atenção', text: 'Existe pelo menos um pagamento com boleto registrado. Deseja CANCELAR a conta mesmo assim ?', acceptText: 'Sim', cancelText: 'Não', accept: this.cancelarRequest
            });
        } else {
            this.$vs.dialog({
                type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja CANCELAR a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.cancelarRequest
            });
        }
    },
    cancelarRequest(){
        this.submeter("/CancelarConta");
    },
    duplicar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja duplicar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.duplicarRequest
        });
    },
    duplicarRequest(){
        this.submeter("/DuplicarConta");
    },
    duplicarMultiplo(){
       this.popupDuplicar.popupActive = true;
       this.popupDuplicar.quantidadeDuplicacao = 0;
    },
    duplicarMultiploRequest(){
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
        params.append('quantidadeDuplicacao', this.popupDuplicar.quantidadeDuplicacao);   
                
        axios.post(URL_SERVLET + "/CriarContaMensalidades", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - duplicarRequest - " + error); 
        })          
    },
    aprovar(){
        this.popupAprovar.popupActive = true;
        this.popupAprovar.tipoPagamento = 'BOLETO';        
    },
    aprovarRequest(){
        this.submeter("/AprovarConta", this.popupAprovar.tipoPagamento);
    },
    gravarAprovar(){
        this.popupInserirAprovar.popupActive = true;
        this.popupInserirAprovar.tipoPagamento = 'BOLETO';        
    },
    gravarAprovarRequest(){
        this.submeter("/InserirAprovarConta", this.popupInserirAprovar.tipoPagamento);
    },
    gravar() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja gravar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.gravarRequest
        });
    },
    gravarRequest() {        
        this.submeter("/GravarConta");
    },
    submeter(urlPost, tipoLancamento) {        
        if (this.formularioValido()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    

            if (this.data_local.hasOwnProperty('id')) {
                params.append("id", this.data_local.id);
            }
            params.append("unidadeOperacional.id", this.data_local.unidadeOperacional.id);
            params.append("unidadeOperacional.nome", this.data_local.unidadeOperacional.nome);
            params.append("contaPlanoConta.id", this.data_local.contaPlanoConta.id);
            params.append("contaPlanoConta.nome", this.data_local.contaPlanoConta.nome);
            params.append("favorecido.id", this.data_local.favorecido.id);
            params.append("favorecido.nome", this.data_local.favorecido.nome);
            params.append("instituicao.id", this.data_local.instituicao.id);
            params.append("instituicao.nome", this.data_local.instituicao.nome);
            params.append("vencimento", this.data_local.vencimento);
            params.append("formaPagamento", this.data_local.formaPagamento);
            params.append("valor", this.data_local.valor);

            if (this.data_local.dataProgramadaEnvioAviso) {
                params.append("dataProgramadaEnvioAviso", this.data_local.dataProgramadaEnvioAviso);
            }

            if (this.data_local.percentualDescontoPontualidade) {
                params.append("percentualDescontoPontualidade", this.data_local.percentualDescontoPontualidade);
                params.append("diasAntecedentesVencimentoParaDesconto", this.data_local.diasAntecedentesVencimentoParaDesconto);
            }

            if (this.data_local.numeroConta) {
                params.append("numeroConta", this.data_local.numeroConta);
            }

            if (this.data_local.contratoRecibo) {
                params.append("contratoRecibo", this.data_local.contratoRecibo);
            }
            if (this.data_local.numeroNotaFiscal) {
                params.append("numeroNotaFiscal", this.data_local.numeroNotaFiscal);
            }
            if (this.data_local.complemento) {
                params.append("complemento", this.data_local.complemento);
            }

            if (tipoLancamento) {
                params.append("tipoLancamento", tipoLancamento);
            }

            params.append("JSONItems", JSON.stringify(this.listaItensContaAReceber));

            axios.post(URL_SERVLET + urlPost, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Conta.erroOperacao) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Conta.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                                                
                        this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Conta.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Conta;  

                        if ( this.data_local.itemList && Array.isArray( this.data_local.itemList)) {                    
                           this.listaItensContaAReceber =  this.data_local.itemList;
                        } else if ( this.data_local.itemList &&  !Array.isArray( this.data_local.itemList) ) {                    
                            this.listaItensContaAReceber = [];
                            this.listaItensContaAReceber.push( this.data_local.itemList);
                        } else {                    
                            this.listaItensContaAReceber = [];
                        }
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
    
        if (!this.data_local.unidadeOperacional) { this.errorsValidacao.push("UNidade Operacional obrigatório"); }
        if (!this.data_local.contaPlanoConta) { this.errorsValidacao.push("Plano de Conta obrigatório"); }
        if (!this.data_local.favorecido) { this.errorsValidacao.push("Fornecedor obrigatório"); }
        if (!this.data_local.vencimento) { this.errorsValidacao.push("Vencimento obrigatório"); }
        if (!this.data_local.valor) { this.errorsValidacao.push("Valor obrigatório"); }
        if (!this.data_local.formaPagamento) { this.errorsValidacao.push("Forma de Pagamento obrigatório"); }
        if (!this.data_local.instituicao) { this.errorsValidacao.push("Instituição obrigatório"); }
        if (parseFloat(this.data_local.valor).toFixed(2) !== parseFloat(this.valorTotalItens).toFixed(2)) { this.errorsValidacao.push("O valor " + parseFloat(this.data_local.valor).toFixed(2) + " da conta difere do total " + parseFloat(this.valorTotalItens).toFixed(2) + " dos itens."); }

        if (!this.listaItensContaAReceber || this.listaItensContaAReceber.length === 0) { this.errorsValidacao.push("Informe pelo menos um item da conta."); }
        
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
    findLancamentoById() {        
        this.$vs.loading({
            container: '#div2-with-loading',
            scale: 0.6
        })
        const params = new URLSearchParams();       
        params.append('empresa.id', this.$store.state.AppActiveUser.empresa.id);    
        params.append('id', this.itemLancamento.id);           
                
        axios.post("/Lancamento/RecuperarLancamento", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.itemLancamento = response.data.Lancamento;   
                if (!this.itemLancamento.hasOwnProperty('dataEfetivacao')) {
                    this.$set(this.itemLancamento, 'dataEfetivacao', null);
                }
                if (!this.itemLancamento.hasOwnProperty('valorEfetivado')) {
                    this.$set(this.itemLancamento, 'valorEfetivado', null);
                }
                if (!this.itemLancamento.hasOwnProperty('complemento')) {
                    this.$set(this.itemLancamento, 'complemento', null);
                }     

                if (!this.itemLancamento.hasOwnProperty('nfeNumero')) {
                    this.$set(this.itemLancamento, 'nfeNumero', null);
                }                
            }
        })
        .catch((error) => { 
            this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - findById - " + error); 
        })  
    }, 
    formularioValidoItemLancamento() {
        if (!this.itemLancamento.tipo) {
            this.popUpLancamento.mensagem = "Informe o tipo do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }
        if (!this.itemLancamento.instituicao || !this.itemLancamento.instituicao.id) {
            this.popUpLancamento.mensagem = "Informe através de qual instantuição será feito o pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.data) {
            this.popUpLancamento.mensagem = "Informe a data de vencimento do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.valor) {
            this.popUpLancamento.mensagem = "Informe o valor do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        return true;
    },
    formularioValidoItemLancamentoEfetivacao() {
        if ("NAO_INFORMADO" === this.itemLancamento.tipo) {
            this.popUpLancamento.mensagem = "Informe o tipo do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }
        if (!this.itemLancamento.dataEfetivacao) {
            this.popUpLancamento.mensagem = "Informe a data do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.valorEfetivado) {
            this.popUpLancamento.mensagem = "Informe o valor pago";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        return true;
    },
    gravarLancamento(statusLancamento) {
        if (statusLancamento === 'EFETUADO' && !this.formularioValidoItemLancamentoEfetivacao()) {
            return;
        }
        if (this.formularioValidoItemLancamento()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    
            
            if (this.itemLancamento.hasOwnProperty('id')) {
                params.append("id", this.itemLancamento.id);
            }

            params.append("tipo", this.itemLancamento.tipo);
            if (this.itemLancamento.numeroLancamento) {
                params.append("numeroLancamento", this.itemLancamento.numeroLancamento);
            }
            params.append("data", this.itemLancamento.data);
            if (this.itemLancamento.dataEfetivacao) {
                params.append("dataEfetivacao", this.itemLancamento.dataEfetivacao);
            }
            params.append("valor", this.itemLancamento.valor);

            if (this.itemLancamento.valorEfetivado) {
                params.append("valorEfetivado", this.itemLancamento.valorEfetivado);
            }
            if (this.itemLancamento.complemento) {
                params.append("complemento", this.itemLancamento.complemento);
            }
            
            params.append("conta.id", this.data_local.id);
            params.append("instituicao.id", this.itemLancamento.instituicao.id);
            params.append("unidadeOperacional.id", this.data_local.unidadeOperacional.id);
            params.append("status", statusLancamento);
            
            if (this.itemLancamento.descontoPontualidade) {
                params.append("descontoPontualidade", this.itemLancamento.descontoPontualidade);
            }

            if (this.itemLancamento.dataParaDesconto) {
                params.append("dataParaDesconto", this.itemLancamento.dataParaDesconto);
            }

            params.append("enviadoParaJuridico", this.itemLancamento.enviadoParaJuridico);
            params.append("emitirNF", this.itemLancamento.emitirNF);
            
            if (this.itemLancamento.nfeNumero) {
                params.append("nfeNumero", this.itemLancamento.nfeNumero);
            }
            
            axios.post("/Lancamento/GravarLancamento", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Lancamento.erroOperacao) {
                        this.popUpLancamento.mensagem = response.data.Lancamento.mensagemResultadoOperacao;
                        this.popUpLancamento.exibirMensagem = true;                                                
                    } else {                                                
                        this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Lancamento.mensagemResultadoOperacao,
                        });
                        this.itemLancamento = response.data.Lancamento;      
                        
                        if (statusLancamento === "EFETUADO") {
                            this.popUpLancamento.popupActive = false;
                            this.findById();
                        } else if (statusLancamento === "DESEFETUAR") {                            
                            this.findById();                            
                        } else {
                            this.fetchListaLancamentos();                            
                        }
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }        
    },
    excluirLancamento(tr) {
        this.itemLancamento = tr;
        if (tr.boletoRegistrado) {
            this.$vs.dialog({
                type: 'confirm', color: 'warning', title: 'Atenção', text: 'O boleto referente a esse pagamento já está registrado.Deseja excluir o pagamento mesmo assim ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirLancamentoRequest
            });
        } else {
            this.$vs.dialog({
                type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir o pagamento ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirLancamentoRequest
            });
        }
    },
    excluirLancamentoRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.itemLancamento.id);   
                
        axios.post("/Lancamento/RemoverLancamento", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.fetchListaLancamentos();
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    },  
    gerarBoleto(){
        if (!this.data_local.hasOwnProperty('diasEmissaoBoleto') || this.data_local.diasEmissaoBoleto <= 59) {
            let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
            this.gerar("Lancamento/ExibirBoletoLancamento", "BOLETO_" + this.itemLancamento.numeroLancamento + "_" + nomeFavorecidoTratado);
        } else {
            this.$vs.notify({
                title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'danger',
                text: "Boleto não é mais válido. Acima de 59 dias",
            });
        }
    },
    gerarRecibo(){
        let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
        this.gerar("Lancamento/ExibirReciboCliente", "RECIBO_" + this.itemLancamento.numeroLancamento + "_" + nomeFavorecidoTratado);
    },
    gerarCartaCobranca(){
        let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
        this.gerar("Lancamento/ExibirCartaCobranca", "CARTA_COBRANCA_" + this.itemLancamento.numeroLancamento + "_" + nomeFavorecidoTratado);
    },
    gerarFatura(){
        let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
        this.gerar("Lancamento/ExibirFaturaAluguelCliente", "FATURA_" + this.itemLancamento.numeroLancamento + "_" + nomeFavorecidoTratado);
    },
    gerar(urlGeracao, nomeArquivo) {        
                
        this.$vs.loading();
        const params = new URLSearchParams();                
        params.append('id', this.itemLancamento.id);     
        if (this.itemLancamento.numeroNotaFiscal)   {
            params.append('nfeNumero', this.itemLancamento.nfeNumero);     
        }
                
        axios.post(urlGeracao, params, {              
                timeout: 600000, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true,  responseType: 'arraybuffer' } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                  this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {                                                                
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', nomeArquivo + '.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();                
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            this.$vs.loading.close();
        }) 
    }, 
    enviarBoleto(lancamentoSelecionado){
        if (!lancamentoSelecionado.hasOwnProperty('diasEmissaoBoleto') || lancamentoSelecionado.diasEmissaoBoleto > 59) {         
            this.$vs.notify({
                title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'danger',
                text: "Boleto não é mais válido. Acima de " +  lancamentoSelecionado.diasEmissaoBoleto+ " dias",
            });
        } else {
            this.popupEnvioEmail.popupActive = true;
            this.popupEnvioEmail.emailDestinatarioCopia = null;
            this.itemLancamento = lancamentoSelecionado;
        }
    },
    enviarBoletoRequest(){
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.itemLancamento.id);   
        if (this.popupEnvioEmail.emailDestinatarioCopia) { 
            params.append('emailDestinatarioCopia', this.popupEnvioEmail.emailDestinatarioCopia);   
        }
        if (this.popupEnvioEmail.numeroWhatsapp) { 
            params.append('numeroWhatsapp', this.popupEnvioEmail.numeroWhatsapp);   
        }
                
        axios.post("Lancamento/EnviarAvisoVencimentoLancamento", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });                    
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - enviarBoletoRequest - " + error); 
        })          
    },
    verificarAlgumBoletoRegistrado() {
      return this.listaLancamentos.some(lancamento => lancamento.boletoRegistrado === true);
    },
    gerarNFSe(){
        let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
        this.gerar("Lancamento/ExibirNFSeCliente", "NFSE_" + this.itemLancamento.nfeNumero + "_" + nomeFavorecidoTratado);
    },
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>

<style>
.vs-textarea {
    height: 120px !important;
}
</style>
